// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9301 ? "85a27759" : chunkId) + "." + {"2654":"437c19e2cd0b788e","9301":"8230c866a768d0b6"}[chunkId] + ".js";
};